import type { ReactNode } from "react";

/** A question a post raises, with its answer tucked away until the reader opens it. */
export default function Question({ q, children }: { q: string; children: ReactNode }) {
  return (
    <details className="group border-b border-gray-200 dark:border-gray-800 py-1">
      <summary className="flex items-center justify-between gap-4 cursor-pointer list-none py-3 font-semibold text-gray-900 dark:text-gray-100 [&::-webkit-details-marker]:hidden">
        {q}
        <span
          aria-hidden="true"
          className="text-2xl leading-none text-gray-400 transition-transform group-open:rotate-45"
        >
          +
        </span>
      </summary>
      {children}
    </details>
  );
}
